// extracted by mini-css-extract-plugin
module.exports = {"root":"_1-cAGM","titleWithBackground":"_3HZH3K","titleHeading":"FYTmJI","title":"_1pqSgR"};